import { useEffect, useState } from "react";
import { Card, Form } from "react-bootstrap";
import badge from "../assets/images/badge.png";
import axios from "axios";
import { Button } from "../Button/Button";
import { toast } from "react-toastify";
import Loader from "../Loader/Loader";
import Modal from 'react-bootstrap/Modal';
import SignServiceQuoteWithOptionsApprove from "./SignServiceQuoteWithOptionsApprove";
/* ===================== TYPES ===================== */

interface SolutionCode {
  description: string;
  stdAmt: number;
  valueAmt: number;
  imageUrl?: string;
  linkUrl?: string;
  isSelected: boolean;
  isAddon?: boolean;
  solnCode?: string;
  showNotes?: boolean;
  notes?: string;
  quantity?: number;
  optionNumber?: number;
}

interface PricingOption {
  optionNumber: number;
  label: string;
  headerColor: string;
  bodyColor: string;
  isSelected: boolean;
  stdAmount: number;
  valueAmount: number;
  solutionCodes: SolutionCode[];
  isAddon: boolean;
  solnCode: string;
  scShowNotes: boolean;
  scNotes: string;
  quantity: number;
  pricingOption: number;
}

interface ServiceQuotePricing {
  companyCode: string;
  url: string;
  allowToSelectMultipleQuote: boolean;
  smName: string;
  smAddress1: string;
  quoteNum: string;
  quoteName: string;
  quoteDescription: string;
  stdOrValue: "S" | "V";
  potentialSavingsLabel: string;
  savingsLabel: string;
  pricingOptions: PricingOption[];
  termsAndConditionDescription: any;
  techNum: string;
  smContact: string;
}

interface Props {
  data?: ServiceQuotePricing;
    onApproveSuccess: any;
}

/* ===================== COMPONENT ===================== */

const SignServiceQuoteWithOptions = ({ data, onApproveSuccess }: Props) => {
  const [options, setOptions] = useState<PricingOption[]>([]);
  const [isLoading, setLoading] = useState(false);
  const [show, setShow] = useState(false);
  //const [approveandSignData, setApproveandSignData] = useState<any>()
  
  const [isQuoteSigned, setIsQuoteSigned] = useState(false);
  const openModal = () => setShow(true);
  
  const handleClose = (status?: boolean) => {
        setShow(false);

        if (status === true) {
            onApproveSuccess?.();  // reload quote info
        }
    };

    const handleApprovalClose = (status?: boolean) => {
        setShow(false);
        if (status === true) {
            setIsQuoteSigned(true);  // hide Approve button
            onApproveSuccess?.(); 
           // toast.success("Quote approved successfully!");
        }
    };
  useEffect(() => {
    if (data?.pricingOptions) {
      setOptions(data.pricingOptions);
    }
  }, [data]);

  if (!data) return null;

  /* ===================== HANDLERS ===================== */

  const handleSelectOption = async (
    optionNumber: number,
    selected: boolean
  ) => {
    setLoading(true);

    try {
      const url = `${data.url}/api/QuotePricingOptions/pickOption`;

      await axios.post(
        url,
        {
          companyCode: data.companyCode,
          quoteNum: data.quoteNum,
          optionNum: optionNumber,
          select: selected ? true : false,
          techNum: data?.techNum,
        },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        }
      );

      setOptions(prev =>
        data.allowToSelectMultipleQuote
          ? prev.map(o =>
              o.optionNumber === optionNumber
                ? { ...o, isSelected: selected }
                : o
            )
          : prev.map(o => ({
              ...o,
              isSelected:
                o.optionNumber === optionNumber ? selected : false,
            }))
      );
    } catch (e) {
      toast.error("Error updating option");
    } finally {
      setLoading(false);
    }
  };

  const handleApprove = () => {
    if (!options.some(o => o.isSelected)) {
      alert("Please select an option before continue");
      return;
    }

    window.location.href = `/Customer/SignServiceQuoteWithOptions/ApproveAndSign?token=${localStorage.getItem("token")}`;
  };

  
const reloadOptionsQuoteInfo = () => {
   
};

  /* ===================== RENDER ===================== */

  return (
    <>
             <Loader show={isLoading} />
              <Modal show={show} onHide={handleClose} centered>
              <Modal.Header closeButton  className="py-2 px-3" >
                <Modal.Title className="mb-0 fs-6">  {/* fs-6 = smaller font size */}
                    Quote Approval
                </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <SignServiceQuoteWithOptionsApprove optionsdata={options} companyCode={data?.companyCode} quoteNum={data?.quoteNum} url={data?.url} terms={data?.termsAndConditionDescription} techNum={data?.techNum} smContact={data?.smContact} onClose={handleApprovalClose}/>
                </Modal.Body>
                </Modal>
    
 <div className="container-fluid card-style mt-10 p-2" style={{ borderRadius: 8, marginTop: 10 }}>
    <div className="d-flex align-items-center justify-content-between mb-2">
      {/* LEFT: Select / Deselect Switch */}
      <div className="form-check form-switch">
        <input
          className="form-check-input"
          type="checkbox"
          id="selectDeselectSwitch"
          checked = {true}
          
        />
        <label
          className="form-check-label"
          htmlFor="selectDeselectSwitch"
        >
          to select/deselect
        </label>
      </div>

      {/* RIGHT: Approve Button */}
    <Button 
      label='Approve' 
      size='medium'
        onClick={openModal}
      />
      
    </div>

      {/* ===== HORIZONTAL SCROLL ===== */}
      <div
        style={{
          display: "flex",
          gap: "12px",
          overflowX: "auto",
          paddingBottom: "6px",
        }}
      >
        {options.map(option => {
          const savings = option.stdAmount - option.valueAmount;

          return (
            <Card
              key={option.optionNumber}
              className="shadow-sm flex-shrink-0"
              style={{ width: 300, fontSize: "0.9rem" }}
            >
              <Card.Header
                style={{
                  backgroundColor: option.headerColor,
                  padding: "8px 10px",
                }}
              >
                <div className="d-flex justify-content-between align-items-center">
                  <div style={{ fontWeight: 600 }}>
                    <img src={badge} height={20} className="me-1" />
                    {option.label}
                  </div>

                  <Form.Check
                    type="switch"
                    checked={option.isSelected}
                    onChange={e =>
                      handleSelectOption(
                        option.optionNumber,
                        e.target.checked
                      )
                    }
                  />
                </div>
              </Card.Header>

              <Card.Body
                style={{
                  backgroundColor: option.bodyColor,
                  padding: "10px",
                }}
              >
                <div className="text-center mb-2 fw-bold">
                  {data.stdOrValue === "S"
                    ? data.potentialSavingsLabel
                    : data.savingsLabel}{" "}
                  ${savings.toFixed(2)}
                </div>

                <div className="d-flex justify-content-between text-center mb-2">
                  <div>
                    ${option.valueAmount.toFixed(2)}
                    <br />
                    <small>Member</small>
                  </div>
                  <div>
                    ${option.stdAmount.toFixed(2)}
                    <br />
                    <small>Not Member</small>
                  </div>
                </div>

                {/* Solution Codes */}
                <div style={{ fontSize: "0.75em" }}>
                  {option.solutionCodes
                    .filter(x => x.isSelected)
                    .slice(0, 5)
                    .map((sc, i) => (
                      <div
                        key={i}
                        className="d-flex justify-content-between"
                      >
                        <div>* {sc.description}</div>
                        <div>
                          {data.stdOrValue === "S"
                            ? sc.stdAmt.toFixed(2)
                            : sc.valueAmt.toFixed(2)}
                        </div>
                      </div>
                    ))}
                </div>

                {/* Images */}
                <div className="d-flex mt-2" style={{ overflowX: "auto" }}>
                  {option.solutionCodes
                    .filter(x => x.isSelected && x.imageUrl)
                    .map((sc, i) =>
                      sc.linkUrl ? (
                        <a
                          key={i}
                          href={sc.linkUrl}
                          target="_blank"
                          rel="noreferrer"
                        >
                          <img
                            src={sc.imageUrl}
                            style={{ maxHeight: 80, marginRight: 6 }}
                          />
                        </a>
                      ) : (
                        <img
                          key={i}
                          src={sc.imageUrl}
                          style={{ maxHeight: 80, marginRight: 6 }}
                        />
                      )
                    )}
                </div>
              </Card.Body>
            </Card>
          );
        })}
      </div>
    </div>

    </>
  );
};

export default SignServiceQuoteWithOptions;
